import useMountEffect from '@restart/hooks/useMountEffect';
import { RiCrosshair2Line } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import actions from '@/actions';
import AccelerometerModal from '@/components/modals/calibration/Accelerometer';
import { modalManager } from '@/libs/ModalContainer';

const Panel = ({ data: [robot] }) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    modalManager.show(AccelerometerModal, { robot });
    dispatch(actions.command.resetActivePanels());
  });

  return null;
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Accelerometer';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiCrosshair2Line;
Command.Panel = Panel;

export default Command;
